import type { StorePageDraftContent } from "./types";

// These form limits match Observatory’s store-page content schema.
export const blurbMaxCharacters = 260;
export const ctaLabelMaxCharacters = 24;
export const closingLineMaxCharacters = 140;
export const beatTitleMaxCharacters = 24;
export const beatBodyMaxCharacters = 220;
export const minBeats = 3;
export const maxBeats = 4;
export const maxMediaItems = 8;
export const altTextMaxCharacters = 200;
export const linkLabelMaxCharacters = 40;
export const maxStoreLinks = 6;

export const emptyStorePageContent: StorePageDraftContent = {
  icon: null,
  blurb: null,
  cta_label: null,
  closing_line: null,
  play_beats: null,
  hero_media: [],
  show_live_replay: true,
  links: [],
};
